 import axios from 'axios';
 import { notifySessionExpired } from './sessionExpired';

 const axiosServices = axios.create();
 
 // interceptor for http
 axiosServices.interceptors.response.use(
     (response) => response,
     (error) => {
       if (error.response?.status === 403) {
         notifySessionExpired();
       }
       return Promise.reject((error.response && error.response.data) || 'Wrong Services');
     }
 );
 
 export default axiosServices;
 